import { useAuth } from '@/shared/hooks/context/auth';

function useCheckPropertyFields() {
  const { onboardingChecks } = useAuth();

  return { hasFields: !!onboardingChecks?.hasFields };
}

export default useCheckPropertyFields;
